import { useTranslation } from 'react-i18next'
import { useLanguage } from '@/hooks/use-language'
import { Button } from '@/components/ui/button'

export function LanguageSwitcher({ className }: { className?: string }) {
  const { current, toggle } = useLanguage()
  const { t } = useTranslation()

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      className={className}
    >
      {current === 'id' ? t('language.switchEn') : t('language.switchId')}
    </Button>
  )
}
